import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Briefcase, Loader2 } from "lucide-react";
import proApi, { PRO_TOKEN_KEY, proErr } from "../../lib/proApi";
import { Toaster } from "../../components/ui/sonner";
import { ZoomControls, usePageZoom } from "../../components/PageZoom";
import CookieBanner from "../../components/CookieBanner";

const INP = "w-full h-11 rounded-lg border border-slate-300 bg-white px-3 text-slate-900 focus:outline-none focus:ring-2 focus:ring-amber-500/50";

export default function ProLogin() {
  const nav = useNavigate();
  const [f, setF] = useState({ username: "", password: "" });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await proApi.post("/auth/professionista/login", f);
      localStorage.setItem(PRO_TOKEN_KEY, data.token);
      nav("/professionisti/area");
    } catch (ex) { setErr(proErr(ex)); } finally { setBusy(false); }
  };
  const z = usePageZoom();
  return (
    <div className="min-h-screen bg-slate-100 grid place-items-center px-4 py-16" data-testid="pro-login-page">
      <Toaster position="top-center" theme="light" richColors />
      <CookieBanner />
      <ZoomControls z={z} className="fixed top-3 right-3 z-40" />
      <form onSubmit={submit} style={{ zoom: z.zoom / 100 }} className="w-full max-w-sm rounded-2xl bg-white border border-slate-200 shadow-sm p-7 space-y-4">
        <div className="flex items-center gap-2 text-slate-900"><Briefcase className="h-6 w-6 text-amber-600" /><h1 className="text-2xl font-bold">Portale professionisti</h1></div>
        <p className="text-sm text-slate-500">Accedi con le credenziali ricevute dallo studio.</p>
        <input value={f.username} onChange={(e) => setF((s) => ({ ...s, username: e.target.value }))} placeholder="Username" autoComplete="username" className={INP} data-testid="pro-login-username" />
        <input type="password" value={f.password} onChange={(e) => setF((s) => ({ ...s, password: e.target.value }))} placeholder="Password" autoComplete="current-password" className={INP} data-testid="pro-login-password" />
        {err && <p className="text-sm text-red-600" data-testid="pro-login-error">{err}</p>}
        <button type="submit" disabled={busy || !f.username || !f.password} data-testid="pro-login-submit" className="w-full h-11 rounded-lg bg-amber-500 hover:bg-amber-600 disabled:opacity-50 text-slate-950 font-semibold inline-flex items-center justify-center gap-2">
          {busy && <Loader2 className="h-4 w-4 animate-spin" />} Accedi
        </button>
      </form>
    </div>
  );
}
